import React from 'react';
import './Hero.css'

const Hero = () => {
  return( 
  <div className='hero' id="home">
      
      <div class="hero-container">
        <h1>You have landed at the right destination!</h1>
        <p>Navigate through the tabs to explore more!!</p>
      </div>
    
  </div>
    
    
    
);
};

export default Hero;
